import React from 'react'

import { TickMark, TickMarkStem, TickMarkKick } from './styles'

const Tick = () => {
    return (
        <TickMark>
            <TickMarkStem></TickMarkStem>
            <TickMarkKick></TickMarkKick>
        </TickMark>
    )
}

export default Tick
